import { Descriptions } from "antd";
import React, { useState } from "react";
import { EaseDrawer } from "../../../../libs/EaseDrawer";
import { Text1, Text3, Text5 } from "../../../../styles";


const ApprovalDetailsDrawer = (props) => {
  const vendor = props.vendor || {};
  const vendor_profile = vendor.vendor_profile || {};
  const profile = vendor.profile || {};
  const [showVendorModal, setshowVendorModal] = useState(false);

  const renderTitle = () => {
    return (
      <div className="mb-4">
        <Text1 className="d-block" strong>User Approval Details</Text1>
        <Text5 copyable>{vendor.id}</Text5>
      </div>
    )
  };

  const renderBasicDetails = () => {
    return (
      <div className="mt-4">
        <Text3 className="d-block" strong>Basic Details</Text3>
        {/* <Descriptions className='mt-2' title={false} column={1} bordered size="small">
          <Descriptions.Item label="Maker">{vendor.maker ? "Yes" : "No"}</Descriptions.Item>
          <Descriptions.Item label="Checker">{vendor.checker ? "Yes" : "No"}</Descriptions.Item>
          <Descriptions.Item label="Approver">{vendor.approver ? "Yes" : "No"}</Descriptions.Item>
          <Descriptions.Item label="Name">{vendor.maker.name}</Descriptions.Item>
          <Descriptions.Item label="Email Id">{vendor.maker.email}</Descriptions.Item>
          <Descriptions.Item label="Phone Number">{vendor.phone}</Descriptions.Item>
        </Descriptions> */}
      </div>
    )
  }

  return (
    <>
      <EaseDrawer
        className="payout-link-details-drawer"
        visible={props.visible}
        onClose={props.onClose} 
        hideHeader 
        hideFooter 
        width={525}
        >
        <div className="mt-3">
          {renderTitle()}
          {renderBasicDetails()}
        </div>
      </EaseDrawer>
    </>
  )
};

export { ApprovalDetailsDrawer };
